export const SCREENS = {
  SELECT_SCREEN: "SELECT_SCREEN",
  INTRO: "INTRO",
  PROTOTYPE: "PROTOTYPE",
  QUANT: "QUANTS",
  VERBAL: "VERBAL",
  ENDING: "ENDING",
  FEEDBACK: "FEEDBACK",
};

export const ASSISTANT_STATUS = {
  IDLE: "idle",
  SPEAKING: "speaking",
};

export const TUTOR_SESSION_PHASE = {
  INTRO: "INTRO",
  QUESTION: "QUESTION",
  ANSWER: "ANSWER",
  ENDING: "ENDING",
};

export const TUTOR_SESSION_PHASE_STATUS = {
  LOADING: "LOADING",
  SPEAKING: "SPEAKING",
  LISTENING: "LISTENING",
};

export const ANNOTATION_ACTION = {
  HIGHLIGHT: "highlight",
  UNDERLINE: "underline",
  CROSSEDOUT: "crossed-off",
  STRIKETHROUGH: "strike-through",
  BOX: "box",
  BRACKET: "bracket",
  CIRCLE: "circle",
};

// UI layout constants
export const SCRATCHPAD_WIDTH = 320;
